const formatMembershipTag = (membershipTag?: string) => {
  switch (membershipTag) {
    case 'PREMIUM':
      return 'Premium';
    case 'PREMIUM_DUO':
      return 'Premium Dúo';
    case 'FAMILIAR':
      return 'Premium Familiar';
    case 'LITE':
      return 'Premium Lite';
    default:
      return null;
  }
};

export default formatMembershipTag;
